(function () {
  //최근검색어
  //BTOCSITE-76808 검색결과 URL hash에 의한 방문로그 중첩 수집 이슈 개선
  var recentItemTemplate =
    '<li><span class="box"><a href="/search?keyword={{text}}&tab=all" data-value="{{text}}" data-contents="최근 검색어">{{disp_text}}</a><button type="button" class="btn-delete" title="검색어 삭제"><span class="blind">삭제</span></button></span></li>';
  //추천검색어
  //BTOCSITE-76808 검색결과 URL hash에 의한 방문로그 중첩 수집 이슈 개선
  var popularItemTemplate =
    '<li><a href="/search?keyword={{keyword}}&tab=all" data-value="{{keyword}}">{{#if type=="Y"}}<span class="flag">HIT</span>{{/if}}{{keyword}}</a></li>';
  //LGE PICK
  var pickItemTemplate =
    '<li><a href="{{_linkUrl}}">{{#if _contents!=""}}<span class="flag exhibition">{{_contents}}</span>{{/if}}{{title}}</a></li>';
  //이런 제품을 찾고 계신가요?/오늘의 랭킹 제품
  var prductListTemplate =
	'<li>' +
	'  <a href="{{_modelUrlPath}}" class="item__link">' +
	'    <div class="item__image">' +
	'      <img src="{{smallImageAddr}}" alt="">' +
	'    </div>' +
	'    <div class="item__info">' +
	'      <div class="item__name">' +
	'        <span class="main-title">' +
	'          <span class="main">{{#raw modelDisplayName}}{{#if _keywdNmText!=""}}<em class="sub">{{_keywdNmText}}</em>{{/if}}{{#if _keywdNmText1!=""}}<em class="sub">{{_keywdNmText1}}</em>{{/if}}</span>' +
	'        </span>' +
	'      </div>' +
	'      <div class="item__model-wrap">' +
	'        <span class="item__sku">{{#raw modelName}}</span>' +
	'      </div>' +
	'    </div>' +
	'  </a>' +
	'</li>';
  //자동완성
  var autoCompleteItemTemplate =
    '<li{{#if type!=""}} class="line-area-wrap"{{/if}}><a href="#{{input}}" data-type="{{type}}">{{#if type!=""}}<span class="line-area01">{{/if}}{{#raw text}}{{#if type!=""}}</span><span class="type">{{typeNm}}</span>{{/if}}</a></li>';
  //자동완성 상품리스트
  var autoCompletePrductListTemplate = 
	'<li>' + 
	'  <a href="{{_modelUrlPath}}" >' + 
	'    <span class="prod-img"><img src="{{_imageUrl}}" onError="lgkorUI.addImgCateErrorEvent(this, \'{{noImageUrl}}\' );" alt="{{modelName}}"></span>' + 
	'    <div class="model-info">' + 
	'        <p class="model-name">{{#raw _modelName}}</p>' + 
	'        <span class="main-title">' +
	'            <span class="main">{{#raw modelDisplayName}}{{#if _keywdNmText!=""}}<em class="sub">{{_keywdNmText}}</em>{{/if}}{{#if _keywdNmText1!=""}}<em class="sub">{{_keywdNmText1}}</em>{{/if}}</span>' + 
	'        </span>' + 
	'    </div>' + 
	'    <span class="txt-direct">제품 바로가기</span>' + 
	'  </a>' + 
	'</li>';
  //자동완성 브랜드리스트
  var autoCompleteBrandListTemplate =
    '<a href="{{_brandUrlPath}}">' +
    '  <span class="brand-img {{css}}"><span class="blind">{{displayName}}</span></span>' +
    '  <span class="txt-direct"><span class="brand-name">{{displayName}}</span> 브랜드관 바로가기</span>' +
    '</a>';
  //자동완성 대체키워드
  var similarTextTemplate =
    '‘<span class="srch-word">{{text}}</span>’(으)로 검색어를 수정합니다.';
  //최근검색어 저장 공유 도메인 e.g. ".lge.co.kr"
  var lgeHost = location.hostname.replace(/.+(?=lge\.)/i, ".");

  var linkHost =
    window.LGEAPPHostName === "localhost" ? "https://www.lge.co.kr" : "";

  var intergratedSearch = {
    init: function () {
      var self = this;
      self.setting();
      self.bindEvents();
    },

    setting: function () {
      var self = this;

      //타이머
      self.searchTimer = null;
      //통합검색 레이어
      self.$searchLayer = $("#layerSearch");
      //검색어 입력input
      self.$inputSearch = self.$searchLayer.find("div.input-sch input.txt");
      self.$inputSearch.attr("data-autofocus", true);
      //검색버튼
      self.$buttonSearch = self.$searchLayer.find("div.input-sch button.btn-search");
      self.$cameraSearch = self.$searchLayer.find("div.input-sch button.btn-camera");
      //검색 전 리스트 공간
      self.$searchKeywordArea = self.$searchLayer.find("div.search-keyword-area");
      //검색 전 제품 공간
      self.$searchProductArea = self.$searchLayer.find("div.search-right-area");
      //최근검색어 리스트 전체삭제
      self.$recentKeywordDelete = self.$searchKeywordArea.find("div.all-delete");
      //최근검색어 리스트
      self.$recentKeywordList = self.$searchKeywordArea.find("div.recent-keyword");
      //추천검색어 리스트
      self.$recommendKeywordList = self.$searchKeywordArea.find("div.popular-keyword");
      //추천검색어 새로보기
      self.$recommendRefresh = self.$searchLayer.find("button.btn-refresh");
      //LGE PICK
      self.$pickKeywordList = self.$searchKeywordArea.find("div.symptom-keyword");
      //오늘의 랭킹 제품
      self.$rankProductList = self.$searchProductArea.find("div.today-ranking");
      //이런 제품을 찾고 계신가요? 제품
      self.$recommendProductList = self.$searchProductArea.find("div.search-recommend");
      //자동 완성 & 검색 결과 공간
      self.$searchResultArea = self.$searchLayer.find("div.search-result-area");
      //자동 완성 리스트
      self.$autoComplete = self.$searchResultArea.find("div.auto-complete");
      //대체키워드
      self.$searchSimilar = self.$searchLayer.find("div.keyword-modify-wrap");
      //NEW GNB(PC) 검색어 입력창, 돋보기
      // 예전엔 버튼 안에 href를 가진 <a>가 별도로 있었지만, 지금은 버튼
      // 자체(.new-header__gnb-search)가 클릭 대상이라 셀렉터를 자기 자신으로 변경.
      self.newGnbSearchBtnSelector = '.new-header__gnb-search';
      //돋보기 숨김
      $('li.search>a[href="#layerSearch"]').removeAttr("data-control");
      $(self.newGnbSearchBtnSelector).removeAttr("data-control");
      self.$searchLayer.attr("aria-hidden", true); // BTOCSITE-97273 [RITM2247366] 닷컴 홈메인 내 리빙서비스 게이트웨이 추가건 (리빙 그랜드 오픈 대응) // 백 버튼 겹침 수정
      // 레이아웃 초기화
      self.hideSearchResultArea();
      self.$searchSimilar.hide();
      self.toggleCamera(true);
    },

    sendSearchPage: function (searchUrl, search, unit, force) {
      var actualSearchUrl = "/sch";
        var fi = actualSearchUrl.indexOf("?");
        var pathOnly = location.pathname;
        var url =
          actualSearchUrl +
          (fi < 0 ? "?" : "&") +
          "keyword=" +
          encodeURIComponent(search) +
          // (unit != null && unit != "" ? "&unit=" + unit : "") +
          // "&force=" +
          // force + "#" + vcui.getUniqId(8)//BTOCSITE-76808 검색결과 URL hash에 의한 방문로그 중첩 수집 이슈 개선

          // 파라미터 추가 &burl=현재url url은 url 인코딩 BTOCSITE-96473
          "&burl=" + encodeURIComponent(pathOnly);
        location.href = url;
    },

    bindEvents: function () {
      var self = this;
      self.$searchLayer.prop('inert',true) // BTOCSITE-77476 웹접근성 수정
      var intergratedClickHandler = function (e) {
          self.preScrollTop = $(window).scrollTop();
          $(window).scrollTop(0);
          e.preventDefault();
          self.getRecentlyViewedCategoryId();
          self.updateRecommendData();  // CSR-11511 TODAY'S PICK 및 새로고침 삭제 요청
          self.updateRecentSearchList();
          self.updateEventBanner();  // 로니 기간 한정 배너 노출 (2026년 7/16 ~ 8/31)

          self.$searchLayer.attr("aria-hidden", false).addClass("open").prop('inert',false) //BTOCSITE-77476 웹접근성 수정
          self.$inputSearch.val("");
          self.$inputSearch.focus();
          var ignoreOverflow = $("body").hasClass("ignore-overflow-hidden");
          if (!ignoreOverflow) {
            $("body").addClass("scroll-lock");
          }
          $('html').css('overflow-y', 'auto');
          
            // 모바일웹,앱 하단메뉴 노출 여부 설정
            lgkorUI.showBottomMeun(false)
      };

      $('li.search>a[href="#layerSearch"]')
          .off(".intergrated")
          .on("click.intergrated", intergratedClickHandler);
      $(".new-header")
          .off(".intergrated", self.newGnbSearchBtnSelector)
          .on("click.intergrated", self.newGnbSearchBtnSelector, intergratedClickHandler);

      //통합검색 닫음
      self.$searchLayer
        .find("button.btn-close")
        .off(".intergrated")
        .on("click.intergrated", function (e) {
          e.preventDefault();
          self.$searchLayer.prop('inert',true) //BTOCSITE-77476 웹접근성 수정
          self.closeSearchPopup();
          if(self.preScrollTop){
            $(window).scrollTop(self.preScrollTop);
          }

            // 모바일웹,앱 하단메뉴 노출 여부 설정
            lgkorUI.showBottomMeun(true)
        });

      //검색버튼
      self.$buttonSearch
        .off(".intergrated")
        .on("click.intergrated", function (e) {
          e.preventDefault();
          clearTimeout(self.searchTimer);

          var searchVal = self.$inputSearch.val();
          self.requestSearchInput(searchVal, "", "1|search");
        });

      self.$inputSearch.keydown(function (key) {
        if (key.keyCode == 13) {
          key.preventDefault();
          self.$buttonSearch.trigger("click");
        }
        if (key.keyCode == 38 || key.keyCode == 40) { 
          var $links = self.$autoComplete.find('div.keyword-list ul li'),
          linkIndex =   0
          count = $links.length;
          if(count > 0 ){ 
            $links.each(function( index, element ) {
              if ($(element).hasClass("on") ) linkIndex = index+1;
              $(element).removeClass("on")
            });
            switch (key.keyCode) {
                case 38:
                    // up
                    linkIndex = Math.max(0, linkIndex - 1) ; 
                    break;
                case 40:
                    // down
                    linkIndex = Math.min(count, linkIndex + 1) ; 
                    break;
            }
            if(linkIndex > 0 ) linkIndex = linkIndex -1;  
            $links.eq(linkIndex).addClass('on'); 
            self.$inputSearch.val($links.eq(linkIndex).find('a').attr("href").replace("#", ""));
          }
        }
      });

      // 카메라버튼
      self.$cameraSearch.on("click", function (e) {
        var target = $(e.currentTarget);

        self.callCheckLogin(function (result) {
          var uri = "/my-page/manage-products";

          if (!result.data.isLogin) {
            lgkorUI.alert(
              "<h6>보유제품을 등록하시려면<br />로그인이 필요합니다.</h6>",
              {
                ok: function () {
                  // 보유제품 페이지로 던지면 미로그인시 로그인 페이지로 가기에
                  if (uri) lgkorUI.goUrl({ href: uri + "?searchQr=qr" });
                },
              },
              target
            );
          } else {
            if (uri) lgkorUI.goUrl({ href: uri + "?searchQr=qr" });
          }
        });
      });

      //검색 타이머
      self.$inputSearch
        .off(".intergrated")
        .on("input.intergrated", function (e) {
        	// search_autocomplete_useyn 메시지 관리 적용
        	if (self.$searchLayer.data("autocompleteUseyn") === "Y") {
	          clearTimeout(self.searchTimer);
	
	          var reg = /[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/ ]/gim;
	          var searchVal = this.value.trim();
	          var searchTestVal = searchVal.replace(reg, "");
	          if (searchVal.length < lgkorUI.SEARCH_AUTOCOMPLETE_MIN_LENGTH || searchTestVal.length < lgkorUI.SEARCH_AUTOCOMPLETE_MIN_LENGTH) {
	            self.openSearchInputLayer(true);
	            self.hideSearchResultArea();
	            self.$searchSimilar.hide();
	            self.toggleCamera(true);
	            return;
	          } else {
	            self.searchTimer = setTimeout(function () {
	              self.requestSearchAutoComplete(searchVal);
	            }, lgkorUI.SEARCH_AUTOCOMPLETE_TIMER);
	            self.toggleCamera(false);
	          }
        	}
        });

      //자동완성 리스트 클릭
      self.$autoComplete
        .off(".intergrated")
        .on("click.intergrated", "div.keyword-list ul li a", function (e) {
          e.preventDefault();
          self.searchItem($(this), true, "3|auto");
          
          //[BTOCSITE-59848] 검색어 집계 세분화
          //var searchVal = $(this).attr("href").replace("#", "");
          //self.sendKeyword(searchVal, "3", "4");
        });

      //자동완성 화살표 클릭
      self.$autoComplete.on(
        "click.intergrated",
        "div.keyword-list ul li button",
        function (e) {
          e.preventDefault();
          self.searchItem($(this).prev("a"), false, "");

          self.$inputSearch.focus();
        }
      );
      
      //추천검색어 클릭
      self.$recommendKeywordList
        .off(".intergrated")
        .on("click.intergrated", "div.keyword-list ul li a", function (e) {
          e.preventDefault();
          self.searchItem($(this), true, "3|popular");
          
          //[BTOCSITE-59848] 검색어 집계 세분화
          //var searchVal = $(this).attr("href").replace("#", "");
          //var searchVal = $(this).attr("data-value");
          //self.sendKeyword(searchVal, "3", "2");
        });

      //최근검색어 클릭
      self.$recentKeywordList
        .off(".intergrated")
        .on("click.intergrated", "div.keyword-list ul li span a", function (e) {
          e.preventDefault();
          self.searchItem($(this), true, "3|recent");
          
          //[BTOCSITE-59848] 검색어 집계 세분화
          //var searchVal = $(this).attr("data-value");
          //self.sendKeyword(searchVal, "3", "1");
        })
        .on(
          "click.intergrated",
          "div.keyword-list ul li span button",
          function (e) {
            //최근검색어 삭제 클릭
            var text = $(this)
              .siblings("a")
              .first()
              .attr("data-value");
            self.removeRecentSearcheText(text);
          }
        )
        .on("click.intergrated", ".all-delete > a", function (e) {
          e.preventDefault();
          self.removeRecentSearcheText();
        });
      
      //추천검색어 새로보기
      self.$recommendRefresh
      .off(".intergrated")
      .on("click.intergrated", function (e) {
        e.preventDefault();
        self.updateRecommendData();
      });
      
      //검색 레이어 바깥영역 클릭시 닫기
      $(document).mouseup(function(e) {
    	  if(self.$searchLayer.hasClass("open")){
    		  if($(e.target).closest(self.$searchLayer).length === 0) {
    			  self.closeSearchPopup();
    		  }
    	  }
      });      

      //자동완성 링크로 이탈 후 검색모달 닫기
      $(window).on('pageshow',function(){
        self.$searchKeywordArea.show();
        self.$autoComplete.hide();
      });
      $(window).on('pagehide',function(){
        self.closeSearchPopup();
      });
    },

    /**
     * 로그인 체크
     */
    callCheckLogin: function (callback) {
      var ajaxUrl = $("header").data("login-info");

      if (!ajaxUrl) {
        return;
      }

      lgkorUI.requestAjaxDataPost(
        ajaxUrl,
        {},
        function (result) {
          if (callback) callback(result);
        }.bind(this)
      );
    },

    openSearchPopup: function () {
      var self = this;
      self.$searchLayer.attr("aria-hidden", false).addClass("open");

      self.$inputSearch.focus();

      //
      var ignoreOverflow = $("body").hasClass("ignore-overflow-hidden");
      if (!ignoreOverflow) {
        $("html, body").css({
          overflow: "hidden",
        });
      }
    },

    closeSearchPopup: function () {
      var self = this;
      clearTimeout(self.searchTimer);
      self.$searchLayer.attr("aria-hidden", true).removeClass("open");

      var ignoreOverflow = $("body").hasClass("ignore-overflow-hidden");
      if (!ignoreOverflow) {
        $("body").removeClass("scroll-lock");
      }
      
      //자동완성
      self.$autoComplete.hide();
      self.openSearchInputLayer(true);
    },

    //검색어창에 입력후 검색
    searchItem: function ($item, isTrigger, kwTypeCd) {
      var self = this;
      var searchVal = $item.attr("data-value") || $item.attr("href").replace("#", "");
      self.$inputSearch.val(searchVal);
      
      var unit = $item.data("type");
      
      if (isTrigger) {
    	//[BTOCSITE-59848] 검색어 집계 세분화
    	clearTimeout(self.searchTimer);
    	//[BTOCSITE-74595][검색] 검색 진입 및 재 검색 시 결과 Tab 지정 - 자동완성클릭
    		self.requestSearchInput(searchVal, unit, kwTypeCd);
    	}
    },

    /**
     * 카메라 버튼 토글
     * @param {boolean} show
     */
    toggleCamera: function (show) {
      var self = this;

      if (isApp() && show) {
        self.$buttonSearch.hide();
        self.$cameraSearch.show();
      } else {
        self.$buttonSearch.show();
        self.$cameraSearch.hide();
      }
    },

    openSearchInputLayer: function (open) {
      var self = this;
      var breakpoint = window.breakpoint;
      var device = breakpoint.name;
      
      if (open) {
        self.updateRecentSearchList();
        self.$searchKeywordArea.show();
        self.$searchProductArea.show();
      } else {
        self.$searchKeywordArea.hide();
        if (device == "mobile") {
        	self.$searchProductArea.hide();
        }else {
        	self.$searchProductArea.show();
        }
      }
    },

    hideSearchResultArea: function () {
      var self = this;
      //자동완성
      self.$autoComplete.hide();
      
      // search_bestrank_useyn 메시지 관리 적용
      if (self.$searchLayer.data("bestrankUseyn") === "N") {
    	  self.hideBestRankArea();
      }
    },
    
    hideBestRankArea: function () {
    	var self = this;
    	var width = "100%";
    	var maxWidth = "768px";
    	$('#layerSearch .search-left-area').css('width', width).css('max-width', maxWidth);
    	$('#layerSearch .inner').css('min-height','auto');
    	self.$searchProductArea.hide(); 
    },
    
    // 검색어 강조 처리 함수 
    highlightSearchText: function(text, search) {
      if (!search || !text) return text;
      
      // 텍스트와 검색어를 소문자로 변환 (한 번만 수행)
      var lowerText = text.toLowerCase();
      var lowerSearch = search.toLowerCase();
      
      // 1. 정확히 일치하는 경우 (대소문자 무시)
      var exactIdx = lowerText.indexOf(lowerSearch);
      if (exactIdx !== -1) {
        return text.substring(0, exactIdx) + 
              '<span class="search-word">' + text.substring(exactIdx, exactIdx + search.length) + '</span>' + 
              text.substring(exactIdx + search.length);
      }
      
      // 2. 공백 제거 일치 검사
      var noSpaceSearch = lowerSearch.split(' ').join('');
      var noSpaceText = lowerText.split(' ').join('');
      
      var noSpaceIdx = noSpaceText.indexOf(noSpaceSearch);
      if (noSpaceIdx !== -1) {
        // 원본 텍스트에서 매칭되는 부분 찾기
        var charMap = [];
        var currentNoSpaceIdx = 0;
        
        // 각 원본 문자의 위치와 공백 제거된 문자열에서의 위치 매핑
        for (var charIndex = 0; charIndex < text.length; charIndex++) {
          if (text[charIndex].trim() !== '') {
            charMap.push({
              origIdx: charIndex,
              noSpaceIdx: currentNoSpaceIdx++
            });
          }
        }
        
        // 시작 위치와 끝 위치 찾기
        var startOrigIdx = -1;
        var endOrigIdx = -1;
        
        for (var mapIndex = 0; mapIndex < charMap.length; mapIndex++) {
          if (charMap[mapIndex].noSpaceIdx === noSpaceIdx) {
            startOrigIdx = charMap[mapIndex].origIdx;
            break;
          }
        }
    
        for (var endMapIndex = 0; endMapIndex < charMap.length; endMapIndex++) {
          if (charMap[endMapIndex].noSpaceIdx === noSpaceIdx + noSpaceSearch.length - 1) {
            endOrigIdx = charMap[endMapIndex].origIdx + 1; // 끝 위치는 포함되어야 함
            break;
          }
        }
        
        if (startOrigIdx !== -1 && endOrigIdx !== -1) {
          return text.substring(0, startOrigIdx) + 
                '<span class="search-word">' + text.substring(startOrigIdx, endOrigIdx) + '</span>' + 
                text.substring(endOrigIdx);
        }
      }      
      return text;
    },
    //검색어 입력중 검색
    requestSearchAutoComplete: function (value) {
      var self = this; 

      lgkorUI.requestKongAjax("searchsvc", "/ajax/v1/search/lyr-autocomplete", {
        method: "GET",                 
        data: {
          keyword : value,
          page : 1 ,
          size : 10 
        },
        success: function(result) {

          var param = result.param;
          var data = result.data;
  
          var searchedValue = value; 
          var showAutoComplete = false;
  
          //자동완성 매핑 상품 리스트 
          var $prductList_div = self.$autoComplete.find("div.prod-direct-list");
          var $prductList_ul = self.$autoComplete.find("div.prod-direct-list ul");
          $prductList_ul.empty(); 
          $prductList_div.hide();       

          //자동완성 매핑 브랜드 리스트
          var arrBrandList = data && data.brandLink instanceof Array ? data.brandLink : [];
          var $brandList_ul = self.$autoComplete.find("div.brandhall");
          $brandList_ul.empty();
          $brandList_ul.hide();
          if (arrBrandList.length > 0) {
            $brandList_ul.show();
            arrBrandList.forEach(function (item, index) {
              // URL 링크 > 집계를 위한 URL 추가
            item._brandUrlPath = self.getUrlPath(item.link, 'com_input_brand', (index+1));
              $brandList_ul.append(vcui.template(autoCompleteBrandListTemplate, item));
              });
              showAutoComplete = true;
          }
          //자동완성 매핑 키워드 리스트
          var arr = data && data.autoComplete instanceof Array ? data.autoComplete : [];
          var $list_ul = self.$autoComplete.find("div.keyword-list ul");
          $list_ul.empty();
          if (arr.length > 0) {
        arr.forEach(function (item, index) {
          var itemKeyword = item.keyword;
          var highlightedText = self.highlightSearchText(itemKeyword, searchedValue); // 검색어 강조 처리
          
          $list_ul.append(
            vcui.template(autoCompleteItemTemplate, {
              input: item.keyword,
              type: item.name,
              typeNm: item.name,
              text: highlightedText
            })
          );
        });
        showAutoComplete = true;
          }
          
          //대체키워드가 있으면 대체키워드를 표시하고 아니면 숨기기
          if (data.similarText) {
              self.$searchSimilar.html(
                vcui.template(similarTextTemplate, { text: data.similarText })
              );
              self.$searchSimilar.addClass("on");
              self.$searchSimilar.show();
          } else {
            self.$searchSimilar.removeClass("on");
              self.$searchSimilar.hide();
          }
          
          //자동완성 갱신
          if (showAutoComplete) {
            self.$autoComplete.show();
            self.openSearchInputLayer(false);
          } else {
            self.hideSearchResultArea();
          }
        },
        error: function(jqXHR) {
          console.log(jqXHR); 
        } 
      });  
    },

    //최근 검색어 삭제
    removeRecentSearcheText: function (text) {
      var self = this;

      // 쿠키 *.lge.co.kr 에 공유하기 위함
      lgkorUI.cookieDomain = lgeHost;

      if (text) {
        lgkorUI.removeCookieArrayValue(lgkorUI.INTERGRATED_SEARCH_VALUE, text);
      } else {
        lgkorUI.deleteCookie(lgkorUI.INTERGRATED_SEARCH_VALUE);
      }

      self.updateRecentSearchList();

      lgkorUI.cookieDomain = null;
    },

	//최근 검색어 추가
	addRecentSearcheText: function (text) {
		// 스페이스바(공백제거) & 특수문자 치환(¡¿¡)
		var _text = text.trim().replaceAll('|','').replaceAll('&','¡¿¡');

		if (!_text || _text.length < 1) return;
		var self = this;

		// 쿠키 *.lge.co.kr 에 공유하기 위함
		lgkorUI.cookieDomain = lgeHost;
		lgkorUI.addCookieArrayValue(lgkorUI.INTERGRATED_SEARCH_VALUE, _text, lgkorUI.MAX_SAVE_RECENT_KEYWORD); 
		self.updateRecentSearchList();
		lgkorUI.cookieDomain = null;
	},

    //최근 검색어 리스트 갱신
    updateRecentSearchList: function () {
      var self = this;

      var cookieValue = lgkorUI.getCookie(lgkorUI.INTERGRATED_SEARCH_VALUE);
      var searchedList = cookieValue ? cookieValue.split("|") : [];

      var arr = searchedList instanceof Array ? searchedList : [];
      var $list_ul = self.$recentKeywordList.find("div.keyword-list ul");
      $list_ul.empty();
      if (arr.length > 0) {
        arr.forEach(function (item, index) {
			var _text = item.trim().replaceAll('¡¿¡','&');
            if(_text) {
                var disp_text = _text;
                if (disp_text.length > 15) disp_text = disp_text.substring(0, 15) + "...";
                $list_ul.append(vcui.template(recentItemTemplate, { text: _text, disp_text: disp_text, hash: vcui.getUniqId(8) }));//BTOCSITE-76808 검색결과 URL hash에 의한 방문로그 중첩 수집 이슈 개선
            }
        });
        self.$recentKeywordDelete.show();
        self.$recentKeywordList.find("div.no-data").hide();
      } else {
    	self.$recentKeywordDelete.hide();
        self.$recentKeywordList.find("div.no-data").show();
      }
    },
    
    //최근본제품 categoryId
    getRecentlyViewedCategoryId: function () {
        var self = this;

        // search_bestrank_useyn 메시지 관리 적용
        if (self.$searchLayer.data("bestrankUseyn") === "Y") {
            var ajaxUrl = self.$searchLayer.data("recentlyViewedUrl");
            lgkorUI.requestAjaxDataPost(ajaxUrl, null, function (result) {
            });
        }
    },

    //기초 데이타 갱신
    updateBasicData: function (categoryId) {
      var self = this;

      // winwin 이벤트 플래그 체크
      lgkorUI.retrieveEventFlag().then(e => {
        if(e) return;

        // search_symptomkeyword_useyn, search_bestrank_useyn 메시지 관리 적용
        if (self.$searchLayer.data("symptomkeywordUseyn") === "Y" || self.$searchLayer.data("bestrankUseyn") === "Y") {
          lgkorUI.requestKongAjax("searchsvc", "/ajax/v1/search/lyr-todays-pick?page=1&size=3", {
            method: "GET",
            data: {},
            success: function(result) {
              var data = result.data;
              //LGE PICK
              var arr = data.list && data.list instanceof Array ? data.list : [];
              if (arr.length > 0) {
                var $list_ul = self.$pickKeywordList.find("ul");
                $list_ul.empty();
                arr.forEach(function (item, index) {
                  //exhibition(기획전),event(스스로해결)
                  item._contents = item.contentsType || "";
                  // URL 링크 > 집계를 위한 URL 추가
                  item._linkUrl = self.getUrlPath(item.linkUrl, 'com_input_tag', (index+1));
                  $list_ul.append(vcui.template(pickItemTemplate, item));
                });
                self.$pickKeywordList.show();
              } else {
                self.$pickKeywordList.hide();
              }

              if (self.$searchLayer.data("bestrankUseyn") === "Y") {
                //이런 제품을 찾고 계신가요?
                arr = data.productList && data.productList instanceof Array ? data.productList : [];
                if (arr.length > 0) {
                  var $recommend_ul = self.$recommendProductList.find("ul");
                  $recommend_ul.empty();
                  arr.forEach(function (item, index) {
                    item._keywdNmText = "";
                    item._keywdNmText1 = "";
                    var keywdNm = item.keywdNm || "";
                    if(keywdNm != "") {
                      if (keywdNm.split("^").length > 1) {
                        item._keywdNms = keywdNm.split("^").map(function (elm, idx) {
                          if (idx === 0) item._keywdNmText = elm.trim();
                          if (idx === 1) item._keywdNmText1 = elm.trim();
                        });
                      } else {
                        item._keywdNmText = keywdNm;
                      }
                    }
                    // URL 링크 > 집계를 위한 URL 추가
                    item._modelUrlPath = self.getUrlPath(item.modelUrlPath, 'com_input_similar', (index+1));
                    $recommend_ul.append(vcui.template(prductListTemplate, item));
                  });
                  self.$recommendProductList.show();
                  self.$rankProductList.hide();
                }else {
                  //오늘의 랭킹
                  ajaxUrl = self.$searchLayer.data("bestRankingUrl");
                  var param = {
                    rankingType: "todays",
                    categoryId: "",
                    filterId:"",
                    keyword:"",
                    categoryIds: "CT50000025,CT50000143,CT50000131,CT50000046,CT50000065,CT50000110,CT50000107,CT50000106,CT50000101,CT50000086,CT50000111,CT50019018,CT50000076,CT50000055"
                  };

                  lgkorUI.requestAjaxDataPost(ajaxUrl, param, function (result) {
                    if(result.data[0].bestRankingProductList != null){
                      var $rank_ul = self.$rankProductList.find("ul");
                      $rank_ul.empty();

                      var bestRankingList = result.data[0].bestRankingProductList;
                      if(bestRankingList.length >= 6){
                        bestRankingList = bestRankingList.slice(0,6);
                      }

                      bestRankingList.forEach(function (item, index) {
                        item._keywdNmText = item.keywdNmA || "";
                        item._keywdNmText1 = item.keywdNmB || "";
                        // URL 링크 > 집계를 위한 URL 추가
                        item._modelUrlPath = self.getUrlPath(item.modelUrlPath, 'com_input_best', (index+1));
                        $rank_ul.append(vcui.template(prductListTemplate, item));
                      });
                      self.$recommendProductList.hide();
                      self.$rankProductList.show();
                    }else{
                      self.$recommendProductList.hide();
                      self.$rankProductList.hide();
                    }
                  });
                }
              }
            },
            error: function(jqXHR) {
              console.log(jqXHR);
            }
          });
        }
      });
    },

    //추천검색어
    updateRecommendData: function () {
	    var self = this;
	    
      // winwin 이벤트 플래그 체크
      lgkorUI.retrieveEventFlag().then(e => {
        if(e) return;

        // search_popularkeyword_useyn 메시지 관리 적용
        if (self.$searchLayer.data("popularkeywordUseyn") === "Y") {
          lgkorUI.requestKongAjax("searchsvc", "/ajax/v1/search/lyr-recommend-keyword", {
            method: "GET",
            data: {},
            success: function(result) {
              var data = result.data;

              //추천검색어
              var arr = data.list && data.list instanceof Array ? data.list : [];

              if (arr.length > 0) {
                var $list_ul = self.$recommendKeywordList.find("div.keyword-list ul");
                $list_ul.empty()
                arr.forEach(function (item, index) {
                  item.hash = vcui.getUniqId(8);//BTOCSITE-76808 검색결과 URL hash에 의한 방문로그 중첩 수집 이슈 개선
                  $list_ul.append(vcui.template(popularItemTemplate, item));
                });
                self.$recommendKeywordList.show();
              } else {
                self.$recommendKeywordList.hide();
              }
            },
            error: function(jqXHR) {
              console.log(jqXHR);
            }
          });
        }
      });
    },

    // 노출 기간 체크 (2026년 9/18 ~ 10/18)
    isBannerVisiblePeriod: function () {
      var now = new Date();
      var year = 2026;
      var startDate = new Date(year, 8, 18, 0, 0, 0);   // 2026년 9월 18일 00:00:00 (Date month는 0-based, 8=9월)
      var endDate = new Date(year, 9, 18, 23, 59, 59);  // 2026년 10월 18일 23:59:59 (9=10월)
      return now >= startDate && now <= endDate;
    },

    // 배너 노출(2026년 9/18 ~ 10/18)
    updateEventBanner: function () {
      var self = this;
      var $banner = self.$recommendKeywordList.siblings("div.exhibition_banner");

      if (self.isBannerVisiblePeriod()) {
        if ($banner.length === 0) {
          var bannerTemplate =
            '<div class="exhibition_banner">' +
            '  <span class="title-line">기획전</span>' +
            '  <div class="banner_box">' +
            '    <a class="banner_link" href="/benefits/exhibitions/detail-PE01011010">' +
            '      <div class="banner_info">' +
            '        <p class="banner_sub">Fine Living, Special Finds</p>' +
            '        <strong class="banner_title">남다르게 ~59%</strong>' +
            '        <div class="banner_date_wrap">' +
            '          <span class="banner_cta">혜택 보러가기</span>' +
            '          <span class="banner_date">9.18 ~ 10.18</span>' +
            '        </div>' +
            '      </div>' +
            '    </a>' +
            '  </div>' +
            '</div>';
          self.$recommendKeywordList.after(bannerTemplate);
        } else {
          $banner.show();
        }
      } else {
        $banner.hide();
      }
    },

    //검색버튼 검색
    requestSearchInput: function (value, unit, kwTypeCd) {
      //BTOCSITE-91 검색 바로가기 개발요청
      var self = this;
      var ajaxUrl = self.$searchLayer.data("allUrl");
      
      if (unit != null && unit != "") {
    	  ajaxUrl = self.$searchLayer.data("unitUrl");
      }

      lgkorUI.requestAjaxData(
        linkHost + "/search/searchKeyword.lgajax",
        { keyword: value },
        function (result) {
          if (result.data && result.data.success == "Y" && result.data.url) {
            if (result.data.linkTarget == "self") {
              location.href = result.data.url;
            } else {
              if (isApp()) {
                if (vcui.detect.isIOS) {
                  var jsonString = JSON.stringify({
                    command: "sendOutLink",
                    url: result.data.url,
                  });
                  webkit.messageHandlers.callbackHandler.postMessage(
                    jsonString
                  );
                } else {
                  void android.openLinkOut(result.data.url);
                }
              } else {
                window.open(result.data.url, "_blank");
              }
            }
          } else {
              //type:1.입력쿼리 > [11] typeDetail:1.검색어입력창
              //type:3.클릭쿼리 > [31] typeDetail:1.최근검색어, [32] 2.인기검색어, [33] 3.연관검색어, [34] 4.자동완성, [35] 5.대체키워드
              if (kwTypeCd != '' &&  kwTypeCd != undefined && kwTypeCd && kwTypeCd.indexOf('|') > -1) {
                var kwTypeCdArr = kwTypeCd.split('|'); 
                self.sendKeyword(value, kwTypeCdArr[0], kwTypeCdArr[1], unit); 
              }
              self.sendSearchPage(ajaxUrl, value, unit, false);
          }
        }
      );
    },
    
    //[BTOCSITE-59848] 검색어 집계 세분화
    //type:1.입력쿼리 > typeDetail:1.검색어입력창
    //type:2.전환쿼리 > typeDetail:1.필터,2.정렬,3.전체보기
    //type:3.클릭쿼리 > typeDetail:1.최근검색어,2.인기검색어,3.연관검색어,4.자동완성,5.대체키워드
    sendKeyword: function (query, type, typeDetail, unit) {
        var gaId = lgkorUI.getCookie("_ga") ; 
        var param = {
          
          tab:  "all",
          orgKeyword:query,
          keyword:"",
          totalCount :  0,
          type: type,
          typeDetail: typeDetail,
          gaId : gaId,
          serviceName: "B2C" 

        }; 
        lgkorUI.requestKongAjax("searchsvc", "/ajax/v1/search/log-keyword-history-save", {
          method: "POST",                
          contentType: "application/json;charset=UTF-8",
          data: JSON.stringify(param),  // Stringify the param object to send as JSON body
          success: function(result) {
            //성공
          },
          error: function(jqXHR) {
            console.log(jqXHR); 
          } 
        });
    },    
    
    // URL 링크 > 집계를 위한 URL 추가
	// 예시) "sKwd=검색어&sTab=unit_product_list&sRank=1-1"
	getUrlPath: function (urlPath, tabType, idx) {
		var _modelUrlPath = urlPath || "";
		var _schVal = this.$inputSearch.val() || "";
		
		if(_modelUrlPath) {
			_modelUrlPath = _modelUrlPath + (_modelUrlPath.indexOf('?') > -1 ? '&' : '?') + (_schVal !='' ? 'sKwd=' + _schVal + '&' : '') + ('sTab='+tabType+'&sRank='+(idx));
		}
		return _modelUrlPath;
	},
 
  };

  $(document).ready(function () {
    intergratedSearch.init();
  });
})();

